import React, { useState, useEffect, useMemo } from "react";
import { Select } from "antd";

import "./ValuesSelect.css";

const { Option } = Select;
export const SAFETY_PROMISE_VALUE = "Safety Promise";

const NRValues = (isPDP) => {
  const values = [
    "On the side of passengers and freight users",
    "Easy to engage with, efficient and dependable partner",
    "Proud to work for Network Rail",
    "Instinctive industry leader",
  ];
  if (!isPDP) values.push(SAFETY_PROMISE_VALUE);

  return values;
};

export const isNotSafetyPromise = (value) => value !== SAFETY_PROMISE_VALUE;

const GBRValues = [
  "Customers can see and feel improvements",
  "An aligned Industry with a clear direction",
  "A simpler sector created",
  "Customers choose rail in droves",
  "A major shift in culture",
  "A more cost effective railway",
  "Trusted to deliver reform",
];

const GBRValuesForPDP = [
  "Own impact",
  "Listen attentively",
  "Create understanding",
  "Build relationships",
  "Organise fairly",
  "Communicate passionately",
];

const ValuesSelect = (props) => {
  const [displayValues, setDisplayValues] = useState(NRValues(props.isPDP));

  useEffect(() => {
    if (props.isGBR) {
      const GBR = props.isPDP ? GBRValuesForPDP : GBRValues;
      setDisplayValues(GBR);
    } else {
      const nrValues = NRValues(props.isPDP);
      setDisplayValues(nrValues);
    }
  }, [props.isGBR, props.isPDP]);

  const label = useMemo(() => {
    if (!props.isGBR) return "Select vision statement";

    return props.isPDP ? "Select behaviour" : "Select strategic goal";
  }, [props.isPDP, props.isGBR]);

  return (
    <Select
      {...props}
      id="valueSelect"
      style={{ width: "72vw", maxWidth: "550px" }}
      value={props.value || ""}
      getPopupContainer={(triggerNode) => triggerNode}
    >
      <Option disabled hidden value="">
        <span style={{ color: "#727272" }}>{label}</span>
      </Option>
      {displayValues &&
        displayValues.map((value) => (
          <Option
            key={value}
            value={value}
            style={{
              color: "#37519d",
              border: "0.25px solid #727272",
              borderRadius: "0",
            }}
          >
            {value}
          </Option>
        ))}
    </Select>
  );
};

export default ValuesSelect;
